import { render, staticRenderFns } from "./UploadMeterReadings.yaml?vue&type=template&id=5c48d3bc&component"
import script from "./UploadMeterReadings.yaml?vue&type=script&lang=ts&component"
export * from "./UploadMeterReadings.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports